<div>
  <h2 data-testid="agent-details-title" class="page-details-title-style">Agent {{agentData.id}}</h2>
</div>

<agent-info [data]="agentData"></agent-info>
